import { postAsync } from './_base';

const postStepAPI = (apiUrl: string, body: string) => {
  return postAsync(apiUrl, undefined, body, false, false, true);
};

const postContactDetails = (apiUrl: string, body: string) => {
  return postAsync(apiUrl, undefined, body, false, false, false);
};

export { postContactDetails, postStepAPI };
